/* eslint-disable react/jsx-no-target-blank */
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import axios from 'axios'
import { Spinner } from 'react-bootstrap'
import { Helmet } from 'react-helmet'
import Header from '../components/layout/Header'
import Footer from '../components/layout/Footer'
import BannerImg from '../assets/images/banners/Banner1.webp'
import {
    Calendar3,
    EnvelopeFill,
    Facebook,
    GeoAltFill,
    Instagram,
    Linkedin,
    PhoneFill,
    TelephoneFill,
    Tiktok,
    Whatsapp,
} from 'react-bootstrap-icons'

const NewsDetail = (props) => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const location = useLocation()
    const passedNews = props.news || location.state?.news

    const [newsdetail, setNewsDetail] = useState(passedNews || {})
    const [contentLoading, setContentLoading] = useState(!passedNews)

    useEffect(() => {
        // get last part of url
        const slug = window.location.pathname
            .split('/')
            .filter((item) => item !== '')
            .slice(-1)[0]

        // get NewsDetail by slug
        axios
            .get(`${process.env.REACT_APP_API_URL}/news/slug/${slug}`)
            .then((res) => {
                if (res.data) {
                    setNewsDetail(res.data)
                    console.log('News data loaded:', res.data)
                    console.log('News Title:', res.data?.title)
                    console.log('News OG title:', res.data?.og_title)
                } else {
                    setNewsDetail([])
                }
            })
            .catch((err) => {
                console.log(err)
            })
            .finally(() => {
                setContentLoading(false)
            })
    }, [])

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{newsdetail?.title || 'Latest Dubai Real Estate News | 800 Homes'}</title>
                <meta
                    name="description"
                    content={
                        newsdetail?.meta_description ||
                        newsdetail?.title ||
                        'Latest Dubai real estate news, trends, and market insights.'
                    }
                />
                <link rel="canonical" href={`https://800homes.ae/news/${newsdetail?.slug || ''}`} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content={newsdetail?.og_title || 'Latest Dubai Real Estate News | 800 Homes'}
                />
                {/* newsdetail?.title || */}
                <meta
                    property="og:description"
                    content={
                        newsdetail?.og_description || 'Latest Dubai real estate news, trends, and market insights.'
                    }
                />
                {/* newsdetail?.meta_description || */}
                {/* newsdetail?.title || */}
                <meta property="og:url" content={`https://800homes.ae/news/${newsdetail?.slug || ''}`} />
                <meta property="og:site_name" content="800homes" />
                <meta property="og:image" content={newsdetail?.og_image || 'https://800homes.ae/og.webp'} />
                {/* newsdetail?.image ||  */}
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />
                <meta property="og:image:secure_url" content={newsdetail?.og_image || 'https://800homes.ae/og.webp'} />
                {/* newsdetail?.image ||  */}
                <meta property="og:image:type" content="image/jpeg" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={newsdetail?.title || 'Latest Dubai Real Estate News | 800 Homes'} />
                <meta
                    name="twitter:description"
                    content={
                        newsdetail?.meta_description ||
                        newsdetail?.title ||
                        'Latest Dubai real estate news, trends, and market insights.'
                    }
                />
                <meta name="twitter:image" content={newsdetail?.image || 'https://800homes.ae/og.webp'} />
            </Helmet>

            {contentLoading ? (
                <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                    <Spinner animation="border" variant="white" />
                </div>
            ) : (
                <>
                    <Header />
                    <section
                        id="website-responsive"
                        className="container-fluid common-banner shadow-800homes"
                        style={{ backgroundImage: `url(${BannerImg})` }}
                    >
                        <div className="row justify-content-center align-items-center">
                            <div className="col-12 col-md-10">
                                <h1 className="lh-sm fw-500 fs-ss-blog text-capitalize text-white text-center">
                                    {newsdetail?.title}
                                </h1>
                            </div>
                        </div>
                    </section>
                    <div className="bg-page py-5 py-md-0" id="website-responsive">
                        {/* <BannerCategory /> */}
                        <section className="pb-md-4">
                            <div className="container-fluid">
                                <div className="row justify-content-center pt-md-5 my-md-5 gy-4" id="">
                                    <div className="col-11 col-md-7 ms-md-auto">
                                        <div className="">
                                            <div className="text-grey pb-3 fs-ss-15">
                                                <Calendar3 className="me-3" />
                                                Date:{' '}
                                                {new Date(newsdetail?.createdAt).toLocaleDateString('en-US', {
                                                    month: 'long',
                                                    day: '2-digit',
                                                    year: 'numeric',
                                                })}
                                            </div>
                                            <div className="text-center shadow mb-4">
                                                <img
                                                    className="w-100"
                                                    src={newsdetail?.image}
                                                    alt={newsdetail?.image_alt || newsdetail?.title}
                                                />
                                            </div>
                                            <div className="mt-5">
                                                <div className="pb-md-5">
                                                    {/* <div className="pb-4 text-white fs-ss-30 lh-sm fw-500">
                                                        {newsdetail?.title}
                                                    </div> */}
                                                    <div className="text-grey fs-ss-18 fw-300 col-12 lh-1-7em">
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: `${newsdetail?.description}`,
                                                            }}
                                                        ></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-11 col-md-3 me-md-auto ms-4 sticky-top">
                                        <div className="sticky-top">
                                            <div className="border-white border-1 border p-4 ">
                                                <div className="fs-ss-30 fw-500 lh-sm text-white">Get In Touch</div>
                                                <div className="fs-ss-16 text-grey fw-300 py-3 lh-1-7em">
                                                    Contact us via phone, email, or in person, and let's discuss how we
                                                    can help you find the perfect home.
                                                </div>

                                                <div className="pt-2 pt-md-3">
                                                    <div className="pb-3">
                                                        <a
                                                            className="text-decoration-none text-grey text-hover-ss-primary fw-300"
                                                            href="tel:80046637"
                                                            target="_blank"
                                                        >
                                                            {' '}
                                                            <TelephoneFill className="text-ss-primary me-2" />{' '}
                                                            80046637{' '}
                                                        </a>
                                                    </div>
                                                    <div className="pb-3">
                                                        <a
                                                            className="text-decoration-none text-grey text-hover-ss-primary fw-300"
                                                            href="tel:+971585746637"
                                                            target="_blank"
                                                        >
                                                            {' '}
                                                            <PhoneFill className="text-ss-primary me-2" />{' '}
                                                            +971-58-574-6637{' '}
                                                        </a>
                                                    </div>
                                                    <div className="pb-3">
                                                        <a
                                                            className="text-decoration-none text-grey text-hover-ss-primary fw-300"
                                                            href="https://api.whatsapp.com/send/?phone=971585746637&text&type=phone_number&app_absent=0"
                                                            target="_blank"
                                                        >
                                                            {' '}
                                                            <Whatsapp className="text-ss-primary me-2" />{' '}
                                                            +971-58-574-6637{' '}
                                                        </a>
                                                    </div>
                                                    <div className="pb-3">
                                                        <a
                                                            className="text-decoration-none text-grey text-hover-ss-primary fw-300"
                                                            href="mailto:inquiry@800homes.ae"
                                                            target="_blank"
                                                        >
                                                            {' '}
                                                            <EnvelopeFill className="text-ss-primary me-2" />{' '}
                                                            inquiry@800homes.ae{' '}
                                                        </a>
                                                    </div>
                                                    <div className="">
                                                        <a
                                                            className="text-decoration-none text-grey text-hover-ss-primary fw-300"
                                                            href="https://share.google/g5V7P4eaoE6Td0ToV"
                                                            target="_blank"
                                                        >
                                                            {' '}
                                                            <GeoAltFill className="text-ss-primary me-2" />
                                                            Office 111, First Floor, Deyaar Head Office Building, Al
                                                            Barsha 1, Dubai
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="border-white border-1 border p-4 mt-4">
                                                <div className="fs-ss-18 text-white py-3">Follow Us</div>
                                                <div className="text-ss-secondary fs-ss-22 text-ss-primary">
                                                    <a
                                                        href="mailto:inquiry@800homes.ae"
                                                        target="_blank"
                                                        className="text-decoration-none text-ss-primary text-hover-ss-primary"
                                                    >
                                                        {' '}
                                                        <EnvelopeFill className="me-3 mb-4" />{' '}
                                                    </a>
                                                    <a
                                                        href="https://api.whatsapp.com/send/?phone=971585746637&text&type=phone_number&app_absent=0"
                                                        target="_blank"
                                                        className="text-decoration-none text-ss-primary text-hover-ss-primary"
                                                    >
                                                        {' '}
                                                        <Whatsapp className="me-3 mb-4" />{' '}
                                                    </a>
                                                    <a
                                                        href="https://www.facebook.com/800Homes"
                                                        target="_blank"
                                                        className="text-decoration-none text-ss-primary text-hover-ss-primary"
                                                    >
                                                        {' '}
                                                        <Facebook className="me-3 mb-4" />{' '}
                                                    </a>
                                                    <a
                                                        href="https://www.instagram.com/800homesae/"
                                                        target="_blank"
                                                        className="text-decoration-none text-ss-primary text-hover-ss-primary"
                                                    >
                                                        {' '}
                                                        <Instagram className="me-3 mb-4" />{' '}
                                                    </a>
                                                    <a
                                                        href="https://www.tiktok.com/@800homes"
                                                        target="_blank"
                                                        className="text-decoration-none text-ss-primary text-hover-ss-primary"
                                                    >
                                                        {' '}
                                                        <Tiktok className="me-3 mb-4" />{' '}
                                                    </a>
                                                    <a
                                                        href="https://www.linkedin.com/company/800-homes-real-estate-brokerage-firm/"
                                                        target="_blank"
                                                        className="text-decoration-none text-ss-primary text-hover-ss-primary"
                                                    >
                                                        {' '}
                                                        <Linkedin className="me-3 mb-4" />{' '}
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>

                    <Footer />
                </>
            )}
        </>
    )
}

export default NewsDetail

// {newsdetail?.featured_image2 && (
//     <div className="pb-4 text-white fs-ss-30 lh-sm fw-500">
//         <img
//             className="w-100"
//             src={newsdetail?.featured_image2}
//             alt={newsdetail?.title}
//         />
//     </div>
// )}
// {newsdetail?.content2 && (
//     <div className="text-grey fs-ss-18 fw-300 col-12 lh-1-7em">
//         <div
//             dangerouslySetInnerHTML={{
//                 __html: `${newsdetail?.content2}`,
//             }}
//         ></div>
//     </div>
// )}
